import React from 'react';
import TableAddEdit from './TableAddEdit.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Popup from './Popup.js';
import db from './db.js';
import SearchPopupButton from './SearchPopupButton.js';
import FactoryDevices from "./FactoryDevices.js"
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary.js';
import SearchTable from './SearchTable.js';
import ShippoPopup from "./ShippoPopup.js";
import HubPopup from "./HubPopup.js";
import HubTable from "./HubTable"
import DeviceTable from "./DeviceTable"
import TextEditor from "./TextEditor"
import FacilityPopup from './FacilityPopup'
var tae = require("./TableAddEdit.js");
var functions = require("./functions.js");
var tableColumnRender = require("./TableColumnRender.js")
const axios = require('axios');

// OrderDetailTable component
export default class OrderDetailTable extends React.Component {

    hubTabDataHeight="60vh";
    shipment_code_options_list= [
        {label:'A', value:'A'}
        ,{label:'B', value:'B'}
        ,{label:'C', value:'C'}
        ,{label:'D', value:'D'}
        ,{label:'E', value:'E'}
        ,{label:'F', value:'F'}
        ,{label:'H', value:'H'}
        ,{label:'I', value:'I'}
        ,{label:'J', value:'J'}
        ,{label:'K', value:'K'}
    ]

    // constructor
    constructor(props) {
        super(props);
        this.deviceTableRef = React.createRef();
        //let item_style_list=[];
        let cols=[];
        try{
            //item_style_list=JSON.parse(this.props.securityObject.systemSettings.item_style_list);
            cols.push({ key: 'checked', title:"checked", editClassName:"hidden", width:10 , noquery:true, noedit:true,render:tableColumnRender.renderChecked.bind(this) } );
            cols.push({ key: 'item_identifier', title:"Identifier", width:10, render:this.renderLinkToInfoButton.bind(this)});
            cols.push({ key: 'shipment_code', title:"Ship Box", width:10, options: this.shipment_code_options_list} );
            cols.push({ key: 'item_type', title:"Type", width:50 } );
            cols.push({ key: 'item_style', title:"Style", width:10 } );
            cols.push({ key: 'quantity', title:"quantity", width:10 });
            cols.push({ key: 'note', title : "Note", width :10, memo:true, noquery:true,editClassName:"line-note-4" ,doNotDisplayInTable:true } );  
            cols.push({ key: 'assigned_to_in_inventory', title : "Assigned to in Inventory", width :10, noedit:true, memo:true, noquery:true,editClassName:"line-note-4-readonly" , render:this.renderFacilitySearchUpdate.bind(this) } );  
            cols.push({ key: 'owner_hub', title : "Assigned to Hub in Inventory", width :10, noquery:true, noedit:true , render:this.renderHubSearchUpdate.bind(this) } );  
            cols.push({ key: 'assigned_to_on_hub', title : "Assigned to on Hub(hub/facility)", width :10, noedit:true, memo:true, noquery:true,editClassName:"line-note-4-readonly", render: tableColumnRender.renderMultiLineText } );  
            cols.push({ key: 'track_status', title : "Tracked", width :10, editClassName:"input-readonly", noedit:true, noquery:true } );  
            cols.push({ key: 'last_seen', title : "Last Seen", width :10, editClassName:"input-readonly", noedit:true, noquery:true, render: tableColumnRender.renderMultiLineText } );  
            cols.push({ key: 'id', title:"delete", width:10, editClassName:"hidden" , noquery:true, noedit:true,render:this.renderdeleteButton.bind(this) } );
            cols.push({ key: 'order_id', title:"Order Id", width:10, editClassName:"hidden", noedit:true,doNotDisplayInTable:true });
        } catch (ex){}        
        this.state={
            //item_style_list:item_style_list,
            postObj:[],
            edited:false,
            selectedObject:false,
            columns:cols,
            facilities:[],
            orderId:false,
            summaryArray:[],
            notePopup:false,
            currentShipmentCode:this.shipment_code_options_list[0].value,
            shippoAddress:false,
            noteToView:false,
            hubId:false,
            allowEditScreen:true,
            hubSearch:false,
            deviceSearch:false,
            orderDetailList:[],
            addButtonRef:undefined,
            hubSearchUpdate:false,
            facilitySearchUpdate:false,
            wearableError:""
        };

    }
    componentDidMount(prevProps) {
        if(this.props.orderId){
            document.getElementById("searchTableInputorder_id").value=this.props.orderId;
            document.getElementById("searchTableInputorder_id").readOnly=true;
            this.queryData();
        }  
        document.getElementById("labelTableInputorder_id").className="hidden";
        document.getElementById("searchTableInputorder_id").className="hidden";
        this.setState({
            addButtonRef:this.deviceTableRef.current.addButtonRef.current
        })
        this.deviceTableRef.current.addButtonRef.current.className="hidden";

    }
    // render
    render() {
        let qry="api/get/orderDetail?";  
        let update="api/updateOrderDetail";
        let trackingnumber="";
        let labelUrl="";
        let trackingUrlProvider="";
        let from="";
        let to="";
        let extra="";
        let packageInfo="";
        let lineItemCount=0;
        try{
            lineItemCount=this.deviceTableRef.current.searchTableRef.current.state.data.length;
        } catch (ex){}
        try{
            trackingnumber=this.state.noteToView.purchaseResult.tracking_number;
            labelUrl=this.state.noteToView.purchaseResult.label_url;
            trackingUrlProvider=this.state.noteToView.purchaseResult.tracking_url_provider;
            from=this.getAddressInfo(this.state.noteToView.shippoRequest.address_from);
            to=this.getAddressInfo(this.state.noteToView.shippoRequest.address_to);
            if(this.state.noteToView.shippoRequest.extra.is_return){
                extra+=`Return Label (note: addresses above are reversed)\n`;
            }
            if(this.state.noteToView.shippoRequest.extra.dangerous_goods
                && this.state.noteToView.shippoRequest.extra.dangerous_goods.contains
            ){
                extra+=`Dangerous Goods\n`;
            }            
            packageInfo=this.state.noteToView.shippoRequest.parcels.length
                +"x"+this.state.noteToView.shippoRequest.parcels.width
                +"x"+this.state.noteToView.shippoRequest.parcels.height
                +" "+this.state.noteToView.shippoRequest.parcels.weight
                +""+this.state.noteToView.shippoRequest.parcels.mass_unit
                
                ;
        } catch(ex){

        }
        return (true)?(
            <div className='relative-div'>
                <table>
                    <tbody>
                    <tr>
                    <td className='plain'>
                            <fieldset>
                                <legend >Mailing Address</legend>
                                        <b>name:</b><br />
                                        {this.props.orderAddress.display_name}<br />
                                        <b>contact:</b><br />
                                        {this.props.orderAddress.display_contact_name}<br />
                                        <b>email/phone:</b><br />
                                        {this.props.orderAddress.display_email}
                                        /{this.props.orderAddress.display_phone}
                                        <br />
                                        <b>company:</b><br />
                                        {this.props.orderAddress.display_company}<br />
                                        <b>address:</b><br />
                                        {this.props.orderAddress.display_full_address}<br />
                            </fieldset>
                            <Tabs>
                                <Tab>Fulfilment Summary</Tab>
                                <Tab disabled={!this.props.lineItem}>Order/Deal</Tab>
                                <TabPanel>
                                    <TableScrollbar  height="50vh">
                                        <ErrorBoundary>
                                            <Table columns={[
                                                        { title: 'Type', key: 'description', width :80,render:tableColumnRender.renderError.bind(this) }
                                                        ,{ title:'Quantity', key: 'quantity', width :20,render:tableColumnRender.renderError.bind(this) }
                                                        ]} 
                                                        dataSource={this.state.summaryArray} 
                                                        />
                                        </ErrorBoundary>
                                    </TableScrollbar>
                                </TabPanel>
                                <TabPanel>
                                    <error>{this.state.wearableError}</error>
                                    <TableScrollbar height="50vh">
                                        <ErrorBoundary>
                                            <Table columns={[
                                                    { key: 'name_description', title:"Description", "width":70 , noquery:true, noedit:true,render:tableColumnRender.renderMultiLineText}                                                //,{ key: 'hs_sku', title:"SKU", width:25 , noquery:true, noedit:true} 
                                                    ,{ key: 'hs_sku', title:"SKU", "width":10 , noquery:true, noedit:true, render:tableColumnRender.renderTextCopyToClipboard} 
                                                    ,{ key: 'quantity', title : "quantity", "width" :10, noquery:true, noedit:true}
                                                    ]} 
                                                    dataSource={this.props.lineItem} 
                                                    />
                                        </ErrorBoundary>
                                    </TableScrollbar>             
                                </TabPanel>
                            </Tabs>
                        </td>
                        <td width="80%" className='plain'>
                            <div>
                                <fieldset>
                                    <legend ></legend>
                                    <br /><br /><br /><br />
                                    <TableAddEdit
                                        queryURL={qry}
                                        updateURL={update}
                                        columns={this.state.columns}
                                        securityObject={this.props.securityObject}
                                        tableHeight={this.hubTabDataHeight}
                                        key="tableAddEditTableAddEdit"
                                        showEditScreen={this.showEditScreen.bind(this)}
                                        afterQuery={this.afterQuery.bind(this)}
                                        ref={this.deviceTableRef}
                                    >
                                    </TableAddEdit>
                                </fieldset>
                            </div>
                            <div style={{position:"absolute", right: "40px", top:"15px"}}>
                                    <table>
                                        <tbody>
                                        <tr>
                                        <td className='plain'>
                                                <fieldset style={{width:"65px"}}>
                                                    <legend >Hub/Device/Misc</legend>
                                                    <button className="smallButton" 
                                                        title="This button us used to add a Hub or Device to this order"
                                                        onClick={this.addDeviceHub.bind(this)}
                                                    >Add</button>&nbsp;
                                                    {lineItemCount}
                                                </fieldset>                                
                                        </td>
                                        <td className='plain'>
                                                <fieldset style={{width:"160px"}}>
                                                    <legend >Wearable</legend>
                                                    <button className="smallButton" title="command to connect to factorypi.  The command to start AutomatedBeaconUpdate will be put into clipboard" onClick={() => functions.openWindow( functions.getSSHUrlForBeaconConfig() ) }>Program Wearables<img alt='' height="15px" src="icons8-clone-figure-32.png"></img></button>
                                                    <SearchPopupButton className="smallButton"
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Import Wearables"
                                                        openSearched={true}
                                                        query={this.props.securityObject.httpServer + "api/get/tempBeaconBatch?"}
                                                        columns={[
                                                                { key: 'batch_no', title:"batch", width :20 }
                                                                ,{ key: 'count', title:"count", width :20, noquery:true }
                                                                ]}
                                                        onClick={(rowData)=>this.importWearables(rowData)}
                                                    ></SearchPopupButton>
                                                    </fieldset>                                
                                        </td>

                                        <td className='plain'>
                                                <fieldset style={{width:"65px"}}>
                                                    <legend >Shipping</legend>
                                                    <button className="smallButton" onClick={()=>{
                                                            this.setState({shippoAddress:this.props.orderAddress});
                                                        }} 
                                                    >Create Label "{this.state.currentShipmentCode}"</button>
                                                </fieldset>                                
                                            </td>

                                            <td className='plain'>
                                                <fieldset>
                                                    <legend >checked operations    (* only on hubs and devices)</legend>
                                                    <input type="checkbox" id="clickAll" style={{"width":"20px"}} onClick={(event)=>{
                                                        this.state.orderDetailList.forEach((item)=>{
                                                            this.state.checked[item.id]=event.target.checked;
                                                            //alert(item.id);
                                                        })
                                                        this.setState({checked:this.state.checked})
                                                    }}></input>                                    
                                                    <button className="smallButton" onClick={()=>this.deleteCheckedItems()}>Delete</button>
                                                    <span className="smallButton">&nbsp;Move to&nbsp;</span>
                                                    <button className="smallButton" onClick={()=>this.moveCheckedItems()}>Ship Box "{this.state.currentShipmentCode}"</button>
                                                    <button className="smallButton" onClick={()=>this.moveCheckedItemsFacility(FacilityPopup.inventoryFacilityId)}>Inventory*</button>
                                                    <button className="smallButton" onClick={()=>this.moveCheckedItemsFacility(FacilityPopup.retiredFacilityId)}>Retired*</button>
                                                    <button className="smallButton" onClick={()=>this.moveCheckedItemsFacility(FacilityPopup.needToBeFixedFacilityId)}>To Be Fixed*</button>
                                                    <button className="smallButton" style={{width:"100px"}} onClick={()=>this.moveCheckedItemsFacility(this.props.facilityId)}>{this.props.facilityName}*</button>
                                                    <SearchPopupButton
                                                        className="smallButton"
                                                        disabled={this.state.hubPopupModified}
                                                        securityObject={this.props.securityObject}
                                                        buttonLabel="Other Facility*"
                                                        query={this.props.securityObject.httpServer + "api/get/facility?"}
                                                        columns={[
                                                                //{ key: 'id', title:"Facility id", width :20 }
                                                                { key: 'facility_name', title:"facility name", width :40 }
                                                                ,{ key: 'facility_address', title:"facility address", width :40 }
                                                                ,{ key: 'facility_city', title:"city", width :40 }
                                                                ,{ key: 'facility_state', title:"state", width :40 }
                                                                ,{ key: 'facility_zip', title:"zip", width :40 }
                                                                ]}
                                                        onClick={(rowData)=>this.moveCheckedItemsFacility(rowData.id)}
                                                    >
                                                    </SearchPopupButton>
                                                </fieldset>

                                            </td>
                                            <td className='plain'>
                                                <fieldset>
                                                    <legend >Misc.</legend>                                    

                                                    <select id="current_shipment_code"
                                                            onChange={()=>{this.setState({currentShipmentCode:document.getElementById("current_shipment_code").value})}}
                                                            className='small-dropdown'
                                                    > 
                                                        {this.shipment_code_options_list.map((e,index) => <option key={index} value={e.value}>{e.label}</option>)}
                                                    </select>
                                                    <button className="smallButton"
                                                        onClick={()=>{
                                                            this.setState({hubSearch:true})
                                                        }}
                                                    >Search Hub</button>
                                                    <button className="smallButton"
                                                        onClick={()=>{
                                                            functions.openWindow("https://apps.goshippo.com/");
                                                        }}
                                                    >shippo</button>                                


                                                </fieldset>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>                            
                        </td>
                    </tr>
                    </tbody>
                </table>
                <Popup trigger={this.state.notePopup} >
                    OrderDetail:{this.state.selectedObject.device_name}
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.setState({notePopup:false}) }>x</button>
                    </div>                     
                </Popup>
                <Popup trigger={this.state.selectedObject} >
                    OrderDetail:{this.state.selectedObject.device_name}
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>                     
                    <Tabs >
                        <TabList>
                            <Tab>OrderDetail</Tab>
                        </TabList>                    
                        <TabPanel >
                            <div className='relative-div'>
                                <table>
                                    <tr>
                                        <td width={"1000px"} className='plain'>
                                            <div style={{height:"50vh"}}>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.saveChanges()}>
                                                                <b>Save (alt-s)</b><br />
                                                                <img alt=''src={ process.env.PUBLIC_URL +"/BarcodeSave.bmp"}></img>
                                                            </button>
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.saveChangesAdd()}>
                                                                Save/Add(alt-a)<br />
                                                                <img alt=''src={ process.env.PUBLIC_URL +"/BarcodeSaveAdd.bmp"}></img>
                                                            </button>
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.closePopup()}>
                                                                Cancel(alt-c)<br />
                                                                <img alt=''src={ process.env.PUBLIC_URL +"/BarcodeCancel.bmp"}></img>
                                                            </button>  
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.edited} onClick={() => this.removeData()}>
                                                                Remove Data(alt-r)<br />
                                                                <img alt=''src={ process.env.PUBLIC_URL +"/BarcodeRemoveData.bmp"}></img>
                                                            </button> 
                                                        </span>
                                                        <span>
                                                            <button onClick={() => this.lookupDevice()}>
                                                                Lookup Data<br />
                                                                <img alt=''src={ process.env.PUBLIC_URL +"/BarcodeEnter.bmp"}></img>
                                                            </button> 
                                                        </span>
                                                        <span>
                                                            <button disabled={!this.state.selectedObject.id} onClick={() => this.deleteItem(this.state.selectedObject)}>
                                                                Delete<br />
                                                                <imgzzz src={ process.env.PUBLIC_URL +"/BarcodeEnter.bmp"}></imgzzz>
                                                            </button> 
                                                        </span>
                                                        <br />  
                                                <span id="message" style={ {color:"red"} }></span>
                                                <h4>The Identifier should be<br />
                                                    - hostname for hub<br />
                                                    - mac address for devices with mac address (Cassia,G1,CradlePoint,Location Indicators,Exit Detectors...)<br />
                                                    - barcode for wearables and everything else (Tracker Storage, Tablet...)<br />
                                                    - A miscellaneous Product
                                                    <SearchPopupButton
                                                            securityObject={this.props.securityObject}
                                                            buttonLabel="Select Misc Product"
                                                            query={this.props.securityObject.httpServer + "api/get/purchasableProducts?"}
                                                            columns={[
                                                                        { key: 'product_name', title:"product name", width :40 }
                                                                    ]}
                                                            onClick={(rowData)=>{
                                                                document.getElementById("inputTableAddEdititem_type").value="misc";
                                                                document.getElementById("inputTableAddEdititem_style").value=rowData.product_name;
                                                                let postObj=this.state.postObj;
                                                                postObj.item_type=document.getElementById("inputTableAddEdititem_type").value;
                                                                postObj.item_style=document.getElementById("inputTableAddEdititem_style").value;
                                                                this.setState( {edited:true,postObj:postObj});
                                                            }}
                                                        >
                                                    </SearchPopupButton>

                                                </h4>
                                                {tae.getEditScreen(
                                                    this.state.columns
                                                    , this.state.selectedObject
                                                    , this.changeFieldValue.bind(this)
                                                    ) 
                                                }

                                            </div>
                                        </td>
                                        <td>
                                            <FactoryDevices 
                                                securityObject={this.props.securityObject}
                                                height="550px"
                                                onRowClick={(rowData) => this.selectMac(rowData) }
                                            ></FactoryDevices>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </TabPanel >
                    </Tabs>  
              
                </Popup>               
                <ShippoPopup
                    shippoAddress={this.state.shippoAddress}
                    onCloseShippoPopup={()=>this.closeShippo()}
                    securityObject={this.props.securityObject}
                    facilityId={this.props.facilityId}
                    orderId={this.props.orderId}
                    sourceOrderId={this.props.sourceOrderId}
                    orderType={this.props.orderType}
                    shipmentCode={this.state.currentShipmentCode}
                    lineItems={this.collectDeviceSummary(this.state.orderDetailList,this.state.currentShipmentCode)}
                >
                </ShippoPopup>  
                <Popup trigger={this.state.noteToView} >
                    Shipment:{this.state.selectedObject.device_name}
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.setState({noteToView:false})}>x</button>
                    </div>  
                    <Tabs >
                        <TabList>
                            <Tab>Shipment</Tab>
                            <Tab>JSON</Tab>
                        </TabList>                    
                        <TabPanel >                        
                            <table>
                                <tr>
                                    <td  className='plain'>

                                        <pre>
                                            <fieldset>
                                                <legend >Tracking</legend>
                                                Tracking Number:
                                                <button className="" title="Tracking Number will be copied to clipboard" onClick={() => functions.copyToClipBoard( trackingnumber ) }>{trackingnumber}<img alt='tracking number' height="15px" src="icons8-clone-figure-32.png"></img></button>
                                                <br />
                                                <a target="_blank" rel="noopener noreferrer" href={labelUrl}>Shipping Label</a><br />
                                                <a target="_blank" rel="noopener noreferrer" href={trackingUrlProvider}>Tracking</a><br />
                                                {packageInfo}
                                            </fieldset>
                                            <fieldset>
                                                <legend >From</legend>
                                                {from}
                                            </fieldset>
                                            <fieldset>
                                                <legend >To</legend>
                                                {to}
                                            </fieldset>
                                            <fieldset>
                                                <legend >Extra</legend>
                                                {extra}
                                            </fieldset>                                            
                                            <fieldset>
                                                <legend >Links</legend>
                                                <div dangerouslySetInnerHTML={{__html:this.props.securityObject.systemSettings.shipping_links}}></div>
                                            </fieldset>
                                        </pre>

                                    </td>
                                    <td  className='plain'>
                                    <iFrame id="labelIFrame" height="450" width="800" title="Shipping Label" src={labelUrl}></iFrame>
                                    </td>
                                </tr>
                            </table>
                        </TabPanel>
                        <TabPanel >
                            <TextEditor 
                                className="NoteTextArea"
                                label="JSON"
                                name="json" id="jsonEditor" 
                                type="json"
                                defaultValue={JSON.stringify(this.state.noteToView,null,2)}>
                            </TextEditor>
                        </TabPanel>
                    </Tabs>
                </Popup>
                <HubPopup
                    hubId={this.state.hubId}
                    visible={this.state.hubId}
                    securityObject={this.props.securityObject}
                    onCloseHubPopup={()=>{this.setState({hubId:false});this.queryData()}}
                >
                </HubPopup>
                <Popup  trigger={this.state.hubSearch} >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => {this.setState({hubSearch:false});this.queryData()}}>x</button>
                    </div>                     
                    <HubTable 
                        securityObject={this.props.securityObject}
                    ></HubTable>
                </Popup>
                <Popup  trigger={this.state.deviceSearch} >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => {this.setState({deviceSearch:false});this.queryData()}}>x</button>
                    </div>                     
                    <DeviceTable 
                        securityObject={this.props.securityObject}
                        search={this.state.deviceSearch}
                    ></DeviceTable> 
                </Popup>
                <Popup  trigger={this.state.hubSearchUpdate} >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => {this.setState({hubSearchUpdate:false});this.queryData()}}>x</button>
                    </div>
                    <h4>Hub Search</h4>   
                    Search for a hub (in this order) to assign this device to
                    <SearchTable
                        securityObject={this.props.securityObject}
                        query={this.props.securityObject.httpServer + "api/get/hubSearch?"}
                        columns={[
                                    { key: 'hostname', title:"hostname", width :40 }
                                    ,{ key: 'display_name', title:"name", width :40 }
                                    ,{ key: 'facility_name', title:"facility", width :40 }
                                ]}
                        onClick={(rowData)=>{
                            db.saveData( this.props.securityObject
                                , {id:this.state.hubSearchUpdate.device_id,hub_id:rowData.id}
                                ,"api/updateDevice"
                                , ()=>this.queryData()
                            );
                            this.setState({hubSearchUpdate:false});
                        }}
                        tableHeight="40vh"
                    >
                    </SearchTable>                                      
                </Popup>                
                <Popup  trigger={this.state.facilitySearchUpdate} >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => {this.setState({facilitySearchUpdate:false});this.queryData()}}>x</button>
                    </div>
                    <h4>Facility Search</h4> 
                    Search for a Facility (in this order) to assign this device to  
                    <SearchTable
                        securityObject={this.props.securityObject}
                        query={this.props.securityObject.httpServer + "api/get/facility?"}
                        columns={[
                                    { key: 'facility_name', title:"facility", width :40 }
                                ]}
                        onClick={(rowData)=>{
                            let apiUrl=undefined;
                            let id= undefined;
                            if (this.state.facilitySearchUpdate.item_type==="device"){
                                apiUrl="api/updateDevice";
                                id=this.state.facilitySearchUpdate.device_id;
                            } else if (this.state.facilitySearchUpdate.item_type==="hub"){
                                apiUrl="api/moveHub"
                                id=this.state.facilitySearchUpdate.hub_id;
                            }
                            if(apiUrl){
                                db.saveData( this.props.securityObject
                                    , {id:id,facility_id:rowData.id}
                                    ,apiUrl
                                    , ()=>this.queryData()
                                );
                            } else {
                                alert("Unable to update.  Can only update devices and hubs")
                            }
                            this.setState({facilitySearchUpdate:false});
                        }}
                        tableHeight="40vh"
                    >
                    </SearchTable>                                      
                </Popup>                
            </div>
        ):"";
    }

    queryData(){
        this.deviceTableRef.current.queryData();
    }
  
    showEditScreen(rowData){
        if(this.state.allowEditScreen){
            let postObj={id:rowData.id}; 
            //, order_id:this.props.orderId, facility_name:this.props.facilityName
            if(rowData.id===-1){
                if(this.props.orderId){
                    postObj.order_id=this.props.orderId;
                    //postObj.note="Firmware:";
                    rowData.order_id=postObj.order_id;
                    //rowData.facility_name=this.props.facilityName;
                    rowData.note=postObj.note;
                }  else {
                    postObj.order_id=1;  //set to inventory
                    rowData.order_id=1;  //set to inventory
                    rowData.facility_name="Wave Inventory";
                }
                if(rowData.shipment_code){
                    postObj.shipment_code=rowData.shipment_code;
                } else {
                    postObj.shipment_code='A';
                }
                postObj.order_type=this.props.orderType;
            }
            if(rowData.item_style){
                postObj.item_style=rowData.item_style;
            } else {
                //postObj.item_style=this.state.device_item_style_list[0].value
            }

            this.setState({
                selectedObject:rowData,
                postObj:postObj
            })

            //document.getElementById("inputTableAddEditassigned_to_in_inventory").readOnly=true;
            //document.getElementById("inputTableAddEditowner_hub").readOnly=true;
            //document.getElementById("inputTableAddEditassigned_to_on_hub").readOnly=true;
            //document.getElementById("inputTableAddEdittrack_status").readOnly=true;
            //document.getElementById("inputTableAddEditlast_seen").readOnly=true;          

            // set focus add key presses
            functions.sleep(1000).then(() => {
                if(document.getElementById("inputTableAddEdititem_identifier")){
                    document.getElementById("inputTableAddEdititem_identifier").focus();

                    // add keypress
                    document.getElementById("inputTableAddEdititem_identifier").onkeydown=this.onKeyDownEvent.bind(this);
                    //document.getElementById("inputTableAddEditserial_number").onkeydown=this.onKeyDownEvent.bind(this);
                    //document.getElementById("inputTableAddEditnote").onkeydown=this.onKeyDownEvent.bind(this);
                    //document.getElementById("labelTableAddEditorder_id").className="hidden"    
                    //document.getElementById("inputTableAddEditorder_id").className="hidden"
                    //document.getElementById("inputTableAddEdittype").onchange=this.changeType.bind(this);
                }    
            });
        }
    }
    // close the popup
    closePopup(){

        if(this.state.edited){
            if(window.confirm("Are you sure you want to exit without saving")){
                this.setState({
                    selectedObject:false
                });
                this.queryData();
            }
        } else {
            this.setState({
                selectedObject:false
            });
            this.queryData();
        }        
    }    
    changeFieldValue(event) {
        //if(event.currentTarget.name==='item_identifier'){
            //functions.normalizeInputForMacAddress(event)
        //}
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        //this.state.postObj[key]=val.replace(/<.*>/, '');;
        let postObj=this.state.postObj
        postObj[key]=val;
        //document.getElementById("inputTableAddEdit"+key).value=this.state.postObj[key];
        this.setState({
            edited:true,
            postObj:postObj
        })
        document.getElementById("message").innerHTML="";
        //if(val.length===17 && key==="item_identifier" 
        //    && val.indexOf("<")===-1 && val.indexOf(">")===-1 ){
        //    this.lookupDevice();
        //    document.getElementById("inputTableAddEdititem_style").focus();
        //}
        if (val.indexOf("<Save>")>=0){
            this.saveChanges();
        }
        //alt a
        if (val.indexOf("<SaveAdd>")>=0){
            this.saveChangesAdd();
        }
        //alt c
        if (val.indexOf("<Cancel>")>=0){
            this.closePopup();
        }
        //alt r
        if (val.indexOf("<RemoveData>")>=0){
            this.removeData();
        }
    }  
    saveChanges(){
        
        // save upper case
        let postObj=this.state.postObj;
        postObj.last_updated_by=this.props.securityObject.userName;
        if(postObj.item_identifier){
            //postObj.item_identifier=postObj.item_identifier;
            this.setState({postObj:postObj});
        }
        if(this.validateScreen()){
            //let thisApp=this;
            db.saveData( this.props.securityObject
                , this.state.postObj
                ,"api/updateOrderDetail"
                , this.afterSave.bind(this)
            );  
        }
    }
    afterSave(res){
        if(res.resultCode===1){
            this.setState({
                edited:false
            })
            this.closePopup();
        } else {
            this.barcodeScannerAlert(JSON.stringify(res));
        }
    }
    afterCheckSaved(thisApp){
        functions.sleep(1000).then(() => {
            thisApp.queryData();
        });
    }

    saveChangesAdd(){
        if(this.validateScreen()){
            //let thispp=this;
            db.saveData( this.props.securityObject
                , this.state.postObj
                ,"api/updateOrderDetail"
                , this.afterSaveAdd.bind(this)
            );  
        }
    }
    afterSaveAdd(res){
        if(res.resultCode===1){
            this.setState({
                edited:false
            })

            // display the saved message
            document.getElementById("message").innerHTML=
                document.getElementById("inputTableAddEdititem_identifier").value
                +" / "
                +document.getElementById("inputTableAddEdititem_style").value
                +" Data Saved";

            // reset values on screen for item_identifier address
            document.getElementById("inputTableAddEdititem_identifier").value="";
            document.getElementById("inputTableAddEdititem_style").value=""
            document.getElementById("inputTableAddEditnote").value=""

            this.showEditScreen({
                id:-1,
                shipment_code:document.getElementById("inputTableAddEditshipment_code").value,
                note:document.getElementById("inputTableAddEditnote").value,
                //type:document.getElementById("inputTableAddEdittype").value
            })
        } else {
            this.barcodeScannerAlert(JSON.stringify(res));
        }
    }


    selectFacility(rowData){
        document.getElementById("inputTableAddEditorder_id").value=rowData.id;
        //document.getElementById("spanTableAddEditfacility_name").innerHTML=rowData.facility_name;
        let postObj=this.state.postObj
        postObj.order_id=rowData.id;
        this.setState({
            edited:true,
            postObj:postObj
        })     
    }

    removeData(){
        document.getElementById("inputTableAddEdititem_identifier").value="";
        document.getElementById("inputTableAddEdititem_style").value="";
        document.getElementById("inputTableAddEdititem_style").note="";
        document.getElementById("inputTableAddEdititem_identifier").focus();
    }

    // https://sps-support.honeywell.com/s/article/How-to-create-standalone-bar-codes-for-ALT-1-char
    /*
    The simple way to create them is using the BarCode Builder program, using the ASCII Control Characters, then adding the required letter.
    For example: ALT+T
    In BarCode Builder select Aztec or Code 128, then click on Control Chars, select STX (0x02 02) double click on it and then click OK. 
    After that add 'T' or 't' in the code. It will result with the ALT+T standalone bar code.
    For CTRL, select ENQ (0x05 05) and add also the required letter.
    There is no way to create a bar code which is containing the control key >Shift<!
*/

    onKeyDownEvent(e){
        if ((e.keyCode === 13)){
            this.lookupDevice();
        }
        //alt s
        if ((e.altKey && e.keyCode === 83)){
            this.saveChanges();
        }
        //alt a
        if ((e.altKey && e.keyCode === 65)){
            this.saveChangesAdd();
        }
        //alt c
        if ((e.altKey && e.keyCode === 67)){
            this.closePopup();
        }
        //alt r
        if ((e.altKey && e.keyCode === 82)){
            this.removeData();
        }
    }
    changeType(event){
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj;
        postObj[key]=val;
        this.setState({postObj:postObj})
    }
    validateScreen(){
        
        console.log(this.deviceTableRef.current.searchTableRef.current.state.data);
        let result=true;
        this.deviceTableRef.current.searchTableRef.current.state.data.forEach( 
            (item)=>{
                if(item.item_identifier===document.getElementById("inputTableAddEdititem_identifier").value && 
                    item.id!==this.state.selectedObject.id){
                        this.barcodeScannerAlert(`Duplicate device identifiers are not allowed (${document.getElementById("inputTableAddEdititem_identifier").value})` )
                        result=false;
                }
            });
/*        let val=document.getElementById("inputTableAddEditmac").value;
        if(val==""){
            return true;
        } else if(val.indexOf(":")<0){
            this.barcodeScannerAlert("Invalid mac address");
            return false;
        } else if (! /^[0-9a-f]{1,2}([.:-])[0-9a-f]{1,2}(?:\1[0-9a-f]{1,2}){4}$/i.test(val)){
            this.barcodeScannerAlert("Invalid mac adderss");
            return false;            
        }
*/            
        return result;
    }
    barcodeScannerAlert(msg){
        alert(msg);
    }
    noNull(val){
        if(val==null){
            return "";
        }
        return val;
    }


    selectMac(rowData){
        document.getElementById("inputTableAddEdititem_identifier").value=rowData.mac;
        let postObj=this.state.postObj;
        postObj.item_identifier=rowData.item_identifier;
        this.lookupDevice();
        this.setState({
            edited:true,
            postObj:postObj
        })
    }
    lookupDevice(){
        let val=document.getElementById("inputTableAddEdititem_identifier").value;
        db.getDeviceLookup( this.props.securityObject,val, (result)=>{
            try {
            let postObj=this.state.postObj;
            document.getElementById("inputTableAddEdititem_style").value=result[0].device_style;
            document.getElementById("inputTableAddEdititem_type").value=result[0].device_type;
            document.getElementById("inputTableAddEditnote").value=result[0].device_description;
            postObj.item_style=result[0].device_style;
            postObj.item_type=result[0].device_type;
            postObj.note=result[0].device_description;
            this.setState({edited:true,postObj:postObj});
            } catch (ex){
                alert(ex)
            }
//            alert(JSON.stringify(result,null,2));
        })
        //"/api/get/deviceLookup"
    }
    afterQuery(refArray, list){
        this.setState({
            summaryArray:this.collectDeviceSummary(list),
            orderDetailList:list,
            checked:{}  // clear out checked
        })
    }
    collectDeviceSummary(list,shipCd){
        let deviceObj={}
        let deviceArray=[];
        let beaconWearableCount=0;
        let katanaWearableCount=0
        list.forEach(element => {
            if(element.item_type==='wearable'){
                if( ["headset","lifeguard","buddy"].indexOf(element.item_style)>-1 ){
                    beaconWearableCount+=element.quantity;
                } else {
                    katanaWearableCount+=element.quantity;
                }
            }
        });
        let wearableError=undefined;
        if(beaconWearableCount!=katanaWearableCount){
            wearableError=`${beaconWearableCount} individual wearbles were imported/ ${katanaWearableCount} wearables were imported from katana`
        }
        try {
        list.forEach(element => {
            let style=element.item_style;
            if (!style){
                style=element.item_identifier
            }
            if(shipCd && element.shipment_code!==shipCd){
                // ignore
            } else if(element.assigned_to_in_inventory==="ship"){
                // ignore
            } else if(element.item_type==="ShippoOrder"){
                // ignore
            } else if(deviceObj[element.item_style]){
                deviceObj[style].count+=element.quantity;
            } else {
                deviceObj[style]={count:element.quantity};
            }
            if(element.item_type==='wearable'){
                deviceObj[style].error=wearableError;
            } else {
                //deviceObj[style].error=undefined;
            }
        });
        } catch(ex){
            console.error(ex);
        }
        Object.keys(deviceObj).map((key) => {
            
            deviceArray.push(
            {   'description':key
                , quantity:deviceObj[key].count
                ,error:deviceObj[key].error
            });
        })
        return deviceArray;
    }
    deleteItem( rowData ){
        if(window.confirm( `Are you sure you want tho delete ${rowData.item_identifier}`)){
            // save upper case
            let postObj={id: rowData.id,record_deleted:"Y"}
            //let thispp=this;
            db.saveData( this.props.securityObject
                , postObj
                ,"api/updateOrderDetail"
                , this.afterSave.bind(this)
            );  

        }
    }
    deleteCheckedItems( rowData ){
        let lstString=tableColumnRender.getCheckedIdListString(this);
        if(window.confirm( `Are you sure you want tho delete the checked items ${lstString}`)){
            // save upper case
            let postObj={id_list: lstString}
            let thisApp=this;
            db.saveData( this.props.securityObject
                , postObj
                ,"api/deleteMultipleOrderDetail"
                , thisApp.afterCheckSaved(thisApp)
            );  

        }
    }    
    moveCheckedItems( rowData ){
        let lstString=tableColumnRender.getCheckedIdListString(this);
        if(window.confirm( `Are you sure you want tho move the checked items to "${this.state.currentShipmentCode}" ${lstString}`)){
            // save upper case
            let postObj={id_list: lstString, ship_cd:this.state.currentShipmentCode}
            let thisApp=this;
            db.saveData( this.props.securityObject
                , postObj
                ,"api/moveMultipleOrderDetail"
                , thisApp.afterCheckSaved(thisApp)
            );  

        }
    }    
      renderItemIdentifier(cellData, rowData, rowIndex){
        let array=[];
        
        // add copy to clipboard
        let btnPlus=React.createElement(
            'img'
            ,{  onClick: (event) => 
                {   
                    event.stopPropagation();
                    functions.copyToClipBoard(cellData);
                    functions.sleep(100).then(()=>{
                        this.setState({selectedObject:false});
                    })
                }
                ,key:"buttonLink"+rowData.id
                ,src:"icons8-clone-figure-32.png"
                ,height:"25px"
            }
    
        );
        array.push(btnPlus); 

        let count=0;
        this.deviceTableRef.current.searchTableRef.current.state.data.forEach( obj=>{
            if(obj.item_identifier && cellData && obj.item_identifier.trim()===cellData.trim()){
                count++;
            }
        })
        let className='';
        let display=cellData;
        if(count>1){
            display+=' (duplicate)'
            className='hub-errors'
        }
        let span=React.createElement(
            'span'
            ,{ 
                className: className
            }
            ,display);
        array.push(span);
        // return div
        let div=React.createElement('div',{}, array );
        return div;    
    }

    renderdeleteButton(cellData, rowData, rowIndex){
        let array=[];
        let btnPlus=React.createElement(
            'img'
            ,{  onClick: (event) => 
                {   
                    event.stopPropagation()
                    this.deleteItem(rowData);
                }
                ,key:"buttonLink"+rowData.id
                ,src:"icons8-delete-trash-24.png"
                ,height:"25px"
            }
    
        );
        array.push(btnPlus);    
        // return div
        let div=React.createElement('div',{}, array );
        return div;   
    }

    renderTracked(cellData, rowData, rowIndex){
        let color="green";
        if(cellData!=="Active"){
            color="red";
        }
        let array=[];
        if(cellData){
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation();
                        this.showDevice(rowData);
                    }
                    ,style : {
                        width:"100%"
                        ,"text-align": "left"
                        ,color:color
                    }
                }
                ,cellData
            );
            array.push(btnPlus);   
        }

        // return div
        let div=React.createElement('div',{}, array );
        return div;                 
    }
    renderHubSearchUpdate(cellData, rowData, rowIndex){
        let array=[];
        if(cellData){
            let fontColor="green";
            let hubList=[];
            this.deviceTableRef.current.searchTableRef.current.state.data.forEach((hub)=>{
                hubList.push(hub.item_identifier);
            })
            if(hubList.indexOf(rowData.owner_hub)<0){
                fontColor="red";
            }            
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation();
                        this.setState({hubSearchUpdate:rowData})
                    }
                    ,style : {
                        width:"100%"
                        ,color:fontColor
                    }
                }
                ,cellData
            );
            array.push(btnPlus);        
        }

        // return div
        let div=React.createElement('div',{}, array );
        return div;   
       
    }
    renderFacilitySearchUpdate(cellData, rowData, rowIndex){
        let array=[];
        if(cellData &&
            (rowData.item_type==="hub" || rowData.item_type==="device")
        ){
            let fontColor="green";
            if(rowData.facility_id!=this.props.facilityId){
                fontColor="red";
            }
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation();
                        this.setState({facilitySearchUpdate:rowData})
                    }
                    ,style : {
                        width:"100%"
                        ,color:fontColor
                    }
                }
                ,cellData
            );
            array.push(btnPlus);        
        }

        // return div
        let div=React.createElement('div',{}, array );
        return div;   
       
    }    
    renderLinkToInfoButton(cellData, rowData, rowIndex){
        let array=[];
        if(!cellData){
            cellData="unknown"
        }
            let btnPlus2=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation();
                        functions.copyToClipBoard(cellData);
                    }
                    ,style : {
                        
                    }
                }
                ,[
                    React.createElement(
                        'img'
                        ,{
                            alt:'ssh'
                            , height:"15px"
                            , src:"icons8-clone-figure-32.png"}
                    )
                ]
            );
            //renove clip board button
            array.push(btnPlus2);                   
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {   
                        event.stopPropagation();
                        this.showDevice(rowData);
                    }
                    ,style : {
                        width:"100%"
                        ,"text-align": "left"
                    }
                }
                ,cellData
            );
            array.push(btnPlus);   

        // return div
        let div=React.createElement('div',{}, array );
        return div;   
    }

    showDevice(rowData){
        
        if(rowData.item_type==='ship'){
            try{
                this.setState({
                    noteToView:JSON.parse(rowData.json)
                    //noteToView:rowData.json
                })
            } catch(ex){
                alert("unable to parse JSON");
                this.setState({
                    noteToView:rowData.json
                    //noteToView:rowData.json
                })                
            }
        }
        if(rowData.item_type==='hub'){
            this.setState({
                hubId:rowData.hub_id
            })
        }
        if(rowData.item_type==='device'){
            this.setState({
                deviceSearch:rowData.item_identifier
            })
        }            
        
        functions.sleep(1000).then(()=>{
            this.setState({selectedObject:false});
        })}
    closeShippo(){
        this.setState({shippoAddress:undefined});
        this.queryData();
    }
    getAddressInfo(addrObj){
        return `${addrObj.company}\n`
        +`${addrObj.name}\n`
        +`${addrObj.street1}\n`
        +`${addrObj.city}, `
        +`${addrObj.state} `
        +`${addrObj.zip} `
        +`${addrObj.country}\n`
        +`email:${addrObj.email}\n`
        +`phone:${addrObj.phone}\n`
        ;

    }
    
    moveCheckedItemsFacility(facilityId){
        if(facilityId && facilityId>0){
            let updateList=[];
            let lstString="";
            this.state.orderDetailList.forEach((item)=>{
                if(item.item_type==='hub' || item.item_type==='device'){
                    if(this.state.checked[item.id]){
                        updateList.push({item_type:item.item_type, id:item.id, facility_id:facilityId, identifier:item.item_identifier });
                        lstString+=" "+item.item_identifier;
                    }
                }
            })   
            if(window.confirm( `Are you sure you want tho move these devices ${lstString}`)){
                // save upper case
                let postObj={device_list: updateList}
                let thisApp=this;
                db.saveData( this.props.securityObject
                    , postObj
                    ,"api/moveMultipleOrderDetailDevices"
                    , thisApp.afterCheckSaved(thisApp)
                );  
            }
        } else {
            alert("Facility must be selected")
        }
    }
    addDeviceHub(){
        this.state.addButtonRef.click();        
    }
    importWearables(rowData){
        let apiUrl=`api/uploadBeaconsForOrder?orderId=${this.props.orderId}`
                                +`&orderType=${this.props.orderType}`
                                +`&shipmentCode=${this.state.currentShipmentCode}`
                                +`&batchNo=${rowData.batch_no}`
        db.saveData( this.props.securityObject
            , {}
            ,apiUrl
            , ()=>{
                    functions.sleep(2000).then(() => {
                        this.queryData();
                    });
                }
        );
/*        
            // Send formData object
            let  headers= { 
                'Session-Id': this.props.securityObject.userSessionId
                ,'enctype':"multipart/form-data"
                };  
            const formData = new FormData();      
            axios.post( this.props.securityObject.httpServer
                                `api/uploadBeaconsForOrder?orderId=${this.props.orderId}`
                                +`&orderType=${this.props.orderType}`
                                +`&shipmentCode=${this.state.currentShipmentCode}`
                        , formData
                        , {headers} )
                .then(async response => {
                //window.alert("success:"+JSON.stringify(response))
                this.queryData();
            })
            .catch(error => {
                window.alert("fail:"+JSON.stringify(error))
            });   ;
            functions.sleep(2000).then(() => {
                this.queryData();
            });
*/
    }

}
